<div class="nova-font-style">
  <kendo-grid [kendoGridBinding]="gridView" [pageSize]="20" [pageable]="gridView && gridView.length > 20"
    [sortable]="true" [resizable]="true" [sort]="sort" filterable="menu" [ngStyle]="gridHeight" id="member-doc-history"
    *ngIf="showGrid">
    <!-- MOBILE VIEW -->
    <kendo-grid-column media="(max-width: 772.98px)" title="Details">
      <ng-template kendoGridCellTemplate let-dataItem>
        <dl>
          <dt></dt>
          <dd>
            <div class="align-left">
              <span class="bold">Date: </span>{{ dataItem.created | date:'MM/dd/yyyy hh:mm a' }}
            </div>
          </dd>
          <dd *ngIf="memberType">
            <div class="align-left">
              <span class="bold">Username:</span>
              {{ dataItem.createdBy }}
            </div>
          </dd>
          <dd *ngIf="showCategory">
            <div class="align-left">
              <span class="bold">Category:</span>
              {{ dataItem.category }}
            </div>
          </dd>
          <dd>
            <div class="align-left">
              <span class="bold">File Name:</span>
              {{ dataItem.fileName }}
            </div>
          </dd>
        </dl>
      </ng-template>
    </kendo-grid-column>
    <!-- DATE -->
    <kendo-grid-column media="(min-width: 773px)" field="created" title="Date" [width]="50"
      [headerClass]="{'align-date': true}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="align-date">
          <div>{{ dataItem.created | date:'MM/dd/yyyy' }}</div>
          <div>{{ dataItem.created | date:'hh:mm a' }}</div>
        </div>
      </ng-template>
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <app-date-range-filter [field]="column.field" [filter]="filter" [filterService]="filterService">
        </app-date-range-filter>
      </ng-template>
    </kendo-grid-column>
    <!-- CATEGORY -->
    <kendo-grid-column media="(min-width: 773px)" field="category" title="Category" [width]="80" *ngIf="showCategory">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
    </kendo-grid-column>
    <!-- USER -->
    <kendo-grid-column media="(min-width: 773px)" field="createdBy" title="Username" [width]="80" *ngIf="memberType">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
    </kendo-grid-column>
    <!-- FILE NAME -->
    <kendo-grid-column media="(min-width: 773px)" field="fileName" title="File Name" [width]="140">
      <ng-template kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
        <kendo-grid-string-filter-menu [column]="column" [filter]="filter" [filterService]="filterService"
          [extra]="false">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-menu>
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="buttonCount"></kendo-pager-numeric-buttons>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-info></kendo-pager-info>
    </ng-template>
  </kendo-grid>
  <app-notification-loading></app-notification-loading>
</div>
